import CashTransferSearchResponseBase from './base/CashTransferSearchResponseBase';

/**
 * @class CashTransferSearchResponse
 * @extends CashTransferSearchResponseBase
 */
class CashTransferSearchResponse extends CashTransferSearchResponseBase {

}

export default CashTransferSearchResponse;
